import FeatureConfig from './FeatureConfig';

export default FeatureConfig;
